import React, {useState} from 'react';
import {FaArrowCircleUp} from 'react-icons/fa';
import "../../styles/ScrollButton.css"
  
const ScrollButton = ({ inView }) =>{
  
  const [visible, setVisible] = useState(false)
  
  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300){
      setVisible(true)
      document.getElementById("scrollTopButton").style.opacity = 1;
      document.getElementById("scrollTopButton").style.transition = "0.6s ease";
    } 
    else if (scrolled <= 300){
      setVisible(false)
      document.getElementById("scrollTopButton").style.opacity = 0;
      document.getElementById("scrollTopButton").style.transition = "0.6s ease";
    }
  };
  
  const scrollToTop = () =>{
    window.scrollTo({
      top: 0, 
      behavior: 'smooth'
    });
  };
  
  window.addEventListener('scroll', toggleVisible);
  
  return (
    <div className='scrollTopButton' id="scrollTopButton" style={inView ? {color: "#222"} : {color: "#f2d729"} }>
     <FaArrowCircleUp onClick={scrollToTop} 
     style={{display: visible ? 'inline' : 'none'}} />
    </div>
  );
}
  
export default ScrollButton;